import script from "./AuthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=6325b479&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6325b479"]])

export default __exports__